import { render } from "./AttachmentsField.vue?vue&type=template&id=0c910b2f"
import script from "./AttachmentsField.vue?vue&type=script&lang=js"
export * from "./AttachmentsField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__